const merchantManagement = [
  {
    tabName: "PayFacs",
    page: [
      {
        name: "PayFacs",
        path: "/merchant-management/payfacs/payfacs",
        authority: "PORTAL",
        sidebarRolePermission: "MERCHANT_PAYFAC",
        rolePermission: "VIEW_PAYFAC",
      },
      {
        name: "Add PayFac",
        path: "/merchant-management/payfacs/add-payfac",
        authority: "PORTAL",
        rolePermission: "CREATE_PAYFAC",
      },
      {
        name: "PayFac Details",
        path: "/merchant-management/payfacs/payfac-details",
        authority: "PORTAL",
        sidebarRolePermission: "MERCHANT_PAYFAC",
        rolePermission: "VIEW_PAYFAC",
        showInSidebar: false,
      },
    ],
  },
  {
    tabName: "Agents",
    page: [
      {
        name: "Agents",
        path: "/merchant-management/agents/agents",
        authority: "PORTAL",
        rolePermission: "MERCHANT_AGENT",
      },
      {
        name: "Agent #",
        path: "/merchant-management/agents/agents-detail",
        authority: "PORTAL",
        rolePermission: "MERCHANT_AGENT",
        showInSidebar: false,
      },
      {
        name: "Add Agent",
        path: "/merchant-management/agents/add-agent",
        authority: "PORTAL",
        rolePermission: "MERCHANT_ADD_AGENT",
      },
    ],
  },

  {
    tabName: "Merchants",
    page: [
      {
        name: "Merchants",
        path: "/merchant-management/merchants/offline-merchants",
        authority: "PORTAL",
        rolePermission: "MERCHANT_OFFLINE_MERCHANT",
      },
      // {
      //   name: "Online Merchants",
      //   path: "/merchant-management/merchants/online-merchants",
      //   authority: "PORTAL",
      //   rolePermission: "MERCHANT_ONLINE_MERCHANT",
      // },
      {
        name: "Merchant #",
        path: "/merchant-management/merchants/offline-merchant-detail",
        authority: "PORTAL",
        rolePermission: "MERCHANT_OFFLINE_MERCHANT",
        showInSidebar: false,
      },
      // {
      //   name: "Online Merchant #",
      //   path: "/merchant-management/merchants/online-merchant-detail",
      //   authority: "PORTAL",
      //   rolePermission: "MERCHANT_ONLINE_MERCHANT",
      //   showInSidebar: false,
      // },
      {
        name: "Add Merchant",
        path: "/merchant-management/merchants/add-offline-merchant",
        authority: "PORTAL",
        rolePermission: "MERCHANT_ADD_OFFLINE_MERCHANT",
      },
      // {
      //   name: "Add Online Merchant",
      //   path: "/merchant-management/merchants/add-online-merchant",
      //   authority: "PORTAL",
      //   rolePermission: "MERCHANT_ADD_ONLINE_MERCHANT",
      // },
      // {
      //   name: "Merchant Profile #",
      //   path: "/merchant-management/merchants/merchant-profile",
      //   authority: "PORTAL",
      //   rolePermission: "",
      //   /*
      //     MAS-330
      //     Remove the permissionTag "MERCHANT_MERCHANT_PROFILE".
      //     - Temporary measures for allowing both online and offline merchant to enter the merchant profile page
      //     - if "MERCHANT_MERCHANT_PROFILE" included in the uiApiPermission group, the Role Permission page will contain one more row which is
      //       not align with the master portal nav side bar, so make the permissionTag empty string "". 
      //     - And need to consider online & offline merchant profile page handling as well if "MERCHANT_MERCHANT_PROFILE" included in the uiApiPermission group.
      //     - In recent situation, if rolePermission: "MERCHANT_MERCHANT_PROFILE", the merchant profile page cannot be accessed becuase this item is filtered
      //       by the role permission handling at master portal, because "MERCHANT_MERCHANT_PROFILE" is not included in the uiApiPermission group.
      //   */
      //   showInSidebar: false,
      // },
    ],
  },
  {
    tabName: "Employees",
    page: [
      {
        name: "Employees",
        path: "/merchant-management/employees/offline-employees",
        authority: "PORTAL",
        rolePermission: "MERCHANT_OFFLINE_EMPLOYEE",
      },
      // {
      //   name: "Online Employees",
      //   path: "/merchant-management/employees/online-employees",
      //   authority: "PORTAL",
      //   rolePermission: "MERCHANT_ONLINE_EMPLOYEE",
      // },
      {
        name: "Employee #",
        path: "/merchant-management/employees/offline-employee-detail",
        authority: "PORTAL",
        rolePermission: "MERCHANT_OFFLINE_EMPLOYEE",
        showInSidebar: false,
      },
      // {
      //   name: "Online Employee #",
      //   path: "/merchant-management/employees/online-employee-detail",
      //   authority: "PORTAL",
      //   rolePermission: "MERCHANT_ONLINE_EMPLOYEE",
      //   showInSidebar: false,
      // },
      {
        name: "Add Employee",
        path: "/merchant-management/employees/add-offline-employee",
        authority: "PORTAL",
        rolePermission: "MERCHANT_ADD_OFFLINE_EMPLOYEE",
      },
      // {
      //   name: "Add Online Employee",
      //   path: "/merchant-management/employees/add-online-employee",
      //   authority: "PORTAL",
      //   rolePermission: "MERCHANT_ADD_ONLINE_EMPLOYEE",
      // },
    ],
  },
];

export default merchantManagement;
